const markers = {
  usa: {
    reverse: true,
    active: false,
    name: 'Estados Unidos',
    left: 40.4,
    top: 7,
    main: true,
  },
  mx: {
    active: true,
    name: 'México',
    left: 37,
    top: 19,
    main: true,
  },
  bz: {
    reverse: true,
    active: false,
    name: 'Belice',
    left: 45,
    top: 20.5,
    main: true,
  },
  bhs: {
    reverse: true,
    active: false,
    name: 'Bahamas',
    left: 53,
    top: 13.5,
    main: true,
  },
  dom: {
    reverse: true,
    active: false,
    name: 'República Dominicana',
    left: 57,
    top: 19,
    main: true,
  },
  jam: {
    reverse: false,
    active: false,
    name: 'Jamaica',
    left: 50,
    top: 20.5,
    main: true,
  },
  brb: {
    reverse: true,
    active: false,
    name: 'Barbados',
    left: 62,
    top: 21,
    main: true,
  },
  gt: {
    active: false,
    name: 'Guatemala',
    left: 41,
    top: 23,
    main: true,
  },
  hnd: {
    reverse: true,
    active: false,
    name: 'Honduras',
    left: 47.5,
    top: 22.5,
    main: true,
  },
  slv: {
    reverse: true,
    active: false,
    name: 'Salvador',
    left: 45,
    top: 24,
    main: true,
  },
  nic: {
    reverse: true,
    active: false,
    name: 'Nicaragua',
    left: 48.5,
    top: 25,
    main: true,
  },
  cr: {
    reverse: true,
    active: false,
    name: 'Costa Rica',
    left: 48,
    top: 27.5,
    main: true,
  },
  pan: {
    active: false,
    name: 'Panamá',
    left: 48,
    top: 31,
    main: true,
  },
  cuw: {
    reverse: true,
    active: false,
    name: 'Curacao',
    left: 56.3,
    top: 25,
    main: true,
  },
  abw: {
    reverse: false,
    active: false,
    name: 'Aruba',
    left: 54,
    top: 25,
    main: true,
  },
  tto: {
    reverse: true,
    active: false,
    name: 'Trinidad y Tobago',
    left: 62,
    top: 26,
    main: true,
  },
  col: {
    reverse: true,
    active: true,
    name: 'Colombia',
    left: 54,
    top: 33,
    main: true,
  },
  ecu: {
    reverse: true,
    active: false,
    name: 'Ecuador',
    left: 51.5,
    top: 38,
    main: true,
  },
  per: {
    reverse: true,
    active: true,
    name: 'Perú',
    left: 54,
    top: 49,
    main: true,
  },
  bol: {
    reverse: true,
    active: false,
    name: 'Bolivia',
    left: 58,
    top: 49,
    main: true,
  },
  chl: {
    active: true,
    name: 'Chile',
    left: 54,
    top: 60,
    main: true,
  },
  pry: {
    reverse: true,
    active: false,
    name: 'Paraguay',
    left: 64,
    top: 50,
    main: true,
  },
  ury: {
    reverse: true,
    active: false,
    name: 'Uruguay',
    left: 66,
    top: 54,
    main: true,
  },
  arg: {
    reverse: true,
    active: true,
    name: 'Argentina',
    left: 60.5,
    top: 54,
    main: true,
  },
  br: {
    reverse: true,
    active: false,
    name: 'Brasil',
    left: 68,
    top: 39,
    main: true,
  },
  nld: {
    reverse: true,
    active: false,
    name: 'Países bajos',
    left: 33,
    top: 1,
  },
  bel: {
    reverse: true,
    active: false,
    name: 'Bélgica',
    left: 27,
    top: 2,
  },
  es: {
    reverse: true,
    active: false,
    name: 'España',
    left: 24,
    top: 7,
  },
  ita: {
    reverse: true,
    active: false,
    name: 'Italia',
    left: 30,
    top: 12,
  },
  aze: {
    reverse: true,
    active: false,
    name: 'Azerbaiyán',
    left: 42.5,
    top: 14,
  },
  chn: {
    reverse: true,
    active: false,
    name: 'China',
    right: 25,
    top: 14,
  },
  jap: {
    reverse: true,
    active: false,
    name: 'Japón',
    right: 20,
    top: 18,
  },
  kor: {
    reverse: true,
    active: false,
    name: 'Corea del sur',
    right: 21.8,
    top: 20,
  },
  vnm: {
    reverse: true,
    active: false,
    name: 'Vietnam',
    right: 22.5,
    top: 24.5,
  },
  idn: {
    reverse: true,
    active: false,
    name: 'Indonesia',
    right: 23,
    top: 39,
  },
  egy: {
    reverse: true,
    active: false,
    name: 'Egipto',
    left: 31.5,
    top: 24,
  },
  isr: {
    reverse: true,
    active: false,
    name: 'Israel',
    left: 37,
    top: 23,
  },
  irq: {
    reverse: true,
    active: false,
    name: 'Iraq',
    left: 42.5,
    top: 23.5,
  },
  pak: {
    reverse: true,
    active: false,
    name: 'Pakistán',
    left: 54.5,
    top: 25.5,
  },
  ind: {
    reverse: true,
    active: false,
    name: 'India',
    left: 60.5,
    top: 32.5,
  },
  are: {
    reverse: true,
    active: false,
    name: 'Emiratos Árabes Unidos',
    left: 48,
    top: 31,
  },





}

export const countries = Object.keys(markers).map(key => ({ ...markers[key], id: key })).reverse()

export const companies = [
  {
    "title": "Sanfer",
    "description": "<p class=\"p1\">Laboratorio Farmac&eacute;utico que comercializa medicamentos de prescripci&oacute;n, Oncol&oacute;gicos, Productos OTC y Productos Veterinarios.</p>",
    "website": "https://fundacionsanfer.org/",
    "smallLogo": "http://206.189.204.88/storage/companies/April2021/PRlrd51Q40QOQtl6LzTm.png",
    "bigLogo": "http://206.189.204.88/storage/companies/April2021/PRlrd51Q40QOQtl6LzTm.png",
    countries: {
      mx: 'mx',
    }
  },
  {
    "title": "Hormona",
    "description": "<p>Es una de las primeras empresas mexicanas que destacaron en la investigaci&oacute;n de productos hormonales, sueros y estudios sobre la Penicilina para incrementar su potencia. La compa&ntilde;&iacute;a provee medicamentos de patentes, gen&eacute;ricos y de marca. Sus principales productos son antibi&oacute;ticos, analg&eacute;sicos, antinflamatorios, gastrointestinales, entre otros.</p>",
    "website": "",
    "smallLogo": "http://206.189.204.88/storage/companies/April2021/ZDCBep1g4p6ydjqG4T9D.png",
    "bigLogo": "http://206.189.204.88/storage/companies/April2021/ZDCBep1g4p6ydjqG4T9D.png",
    countries: {
      mx: 'mx',
    }
  },
  {
    "title": "Grimann",
    "description": "<p>Empresa de clase mundial que cumple con est&aacute;ndares de calidad locales e internacionales y cuenta con los conocimientos t&eacute;cnicos desarrollados por Laboratorios Sanfer y Laboratorios Hormona, empresas con una gran actividad en la industria farmac&eacute;utica mexicana.</p>\r\n<p>Surge con la idea de contar con instalaciones dedicadas para realizar los diferentes procesos de manufactura de productos Farmac&eacute;uticos; controlados mediante un sistema de calidad. Todo esto con la finalidad de ofrecer a los clientes altos niveles de seguridad y servicio, invirtiendo en equipo y tecnolog&iacute;a para ser una industria eficiente y atractiva.</p>",
    "website": "",
    "smallLogo": "http://206.189.204.88/storage/companies/April2021/wXqBlN0EBcgUtECR36k9.png",
    "bigLogo": "http://206.189.204.88/storage/companies/April2021/wXqBlN0EBcgUtECR36k9.png",
    countries: {
      mx: 'mx',
    }
  },
  {
    "title": "Litogrimann",
    "description": "<p>Empresa especializada en impresi&oacute;n con tintas y acabados de distintos materiales en empaques de cart&oacute;n de diversos tipos. Cuenta con m&aacute;s de 20 a&ntilde;os de experiencia en la industria de las artes gr&aacute;ficas, con tecnolog&iacute;a de vanguardia, en sistemas de impresi&oacute;n y m&uacute;ltiples acabados especiales. El personal calificado y sus procesos productivos ofrecen soluciones y alta calidad en la fabricaci&oacute;n de sus productos.</p>",
    "website": "http://www.litogrimann.com.mx/",
    "smallLogo": "http://206.189.204.88/storage/companies/April2021/8n4onOLu5yftnfFWRMwz.png",
    "bigLogo": "http://206.189.204.88/storage/companies/April2021/8n4onOLu5yftnfFWRMwz.png",
    countries: {
      mx: 'mx',
    }
  },
  {
    "title": "Bussie",
    "description": "<p>Farmac&eacute;utica fundada en 1959 y que actualmente cuenta con m&aacute;s de 50 medicamentos de marca y una extensa gama de medicamentos gen&eacute;ricos bajo licencia de Laboratorios Recipe.&nbsp;&nbsp;</p>\r\n<p>Est&aacute; basado en Bogot&aacute;, Colombia y se comercializan medicamentos de prescripci&oacute;n, gen&eacute;ricos, Productos OTC y Productos Veterinarios.&nbsp;</p>\r\n<p>Cuenta con tres centros de manufactura, dos en M&eacute;xico y uno en Colombia, cada uno equipado con tecnolog&iacute;a de punta para la fabricaci&oacute;n adecuada de productos farmac&eacute;uticos&nbsp;</p>",
    "website": "http://bussie.com.co/?r=site/servicios",
    "smallLogo": "http://206.189.204.88/storage/companies/April2021/7dNwW6jGoqfPJ1Yk1HCJ.png",
    "bigLogo": "http://206.189.204.88/storage/companies/April2021/7dNwW6jGoqfPJ1Yk1HCJ.png",
    countries: {
      col: 'col',
    }
  },
  {
    "title": "Labinco",
    "description": "<p>Farmac&eacute;utica colombiana fundada en 1922 dedicada a la producci&oacute;n y comercializaci&oacute;n de medicamentos y productos bot&aacute;nicos para el mercado privado e institucional.&nbsp;</p>\r\n<p>Cuenta con cobertura en la totalidad del territorio colombiano y con una importante participaci&oacute;n de mercado en este segmento nacional.&nbsp;</p>",
    "website": "http://bussie.com.co/?r=site/servicios",
    "smallLogo": "http://206.189.204.88/storage/companies/April2021/lXuOvom0FyDusorWAAof.png",
    "bigLogo": "http://206.189.204.88/storage/companies/April2021/lXuOvom0FyDusorWAAof.png",
    countries: {
      col: 'col',
    }
  },
  {
    "title": "PharmaDorf",
    "description": "<p>Compa&ntilde;&iacute;a farmac&eacute;utica din&aacute;mica y altamente especializada la cual inici&oacute; operaciones en el segmento oftalmol&oacute;gico en el a&ntilde;o 2002.</p>\r\n<p>Basada en Buenos Aires, Argentina, comercializa medicamentos de prescripci&oacute;n y OTC para las l&iacute;neas de: oftalmolog&iacute;a, gastroenterolog&iacute;a, neurolog&iacute;a, urolog&iacute;a, reumatolog&iacute;a, psiquiatr&iacute;a, respiratorio, diabetes, ginecolog&iacute;a y cardiolog&iacute;a.</p>",
    "website": "https://pharmadorf.com.ar/",
    "smallLogo": "http://206.189.204.88/storage/companies/April2021/cznA76HrAYlbTX1fLpEK.png",
    "bigLogo": "http://206.189.204.88/storage/companies/April2021/cznA76HrAYlbTX1fLpEK.png",
    countries: {
      arg: 'arg'
    }
  },
  {
    "title": "Dinafarma",
    "description": "<p class=\"p1\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474;\">Empresa con instalaciones dedicadas para realizar diversos procesos de manufactura de productos Oncol&oacute;gicos. <span class=\"Apple-converted-space\">&nbsp;</span></p>\r\n<p class=\"p2\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474; min-height: 16px;\">&nbsp;</p>\r\n<p class=\"p1\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474;\">Cuenta con &aacute;reas autocontenidas y equipos de alta tecnolog&iacute;a para brindar seguridad al producto, personal y medio ambiente. <span class=\"Apple-converted-space\">&nbsp;</span></p>",
    "website": "",
    "smallLogo": "http://206.189.204.88/storage/companies/April2021/DViZyOfQqWE7YxgM1vw9.png",
    "bigLogo": "http://206.189.204.88/storage/companies/April2021/DViZyOfQqWE7YxgM1vw9.png",
    countries: {
      mx: 'mx'
    }
  },
  {
    "title": "Aerobal",
    "description": "<p class=\"p1\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474;\">Empresa maquiladora de clase mundial. Comprometidos a que los servicios de maquila en la manufactura de productos para el cuidado personal, del hogar y dispositivos m&eacute;dicos satisfagan las expectativas de calidad y servicio de los clientes, las regulaciones aplicables, en un ambiente de mejora continua y productividad.<span class=\"Apple-converted-space\">&nbsp;</span></p>",
    "website": "",
    "smallLogo": "http://206.189.204.88/storage/companies/April2021/N4DF2jE9OZ5d0cP4pQRI.png",
    "bigLogo": "http://206.189.204.88/storage/companies/April2021/N4DF2jE9OZ5d0cP4pQRI.png",
    countries: {
      mx: 'mx'
    }
  },
  {
    "title": "Grupo Portugal",
    "description": "<p class=\"p1\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474;\">Laboratorio localizado en Per&uacute; con 150 a&ntilde;os de experiencia en el mercado el cual busca ofrecer productos de alta calidad en grandes cantidades y a un precio accesible para todo p&uacute;blico. <span class=\"Apple-converted-space\">&nbsp;</span></p>\r\n<p class=\"p2\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474; min-height: 16px;\">&nbsp;</p>\r\n<p class=\"p1\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474;\">Actualmente posee m&aacute;s de 700 productos de la l&iacute;nea cosm&eacute;tica.<span class=\"Apple-converted-space\">&nbsp;</span></p>",
    "website": "https://www.laboratoriosportugal.com/",
    "smallLogo": "http://206.189.204.88/storage/companies/April2021/ZkLGnupBCvfjN5zkndma.png",
    "bigLogo": "http://206.189.204.88/storage/companies/April2021/ZkLGnupBCvfjN5zkndma.png",
    countries: {
      per: 'per'
    }
  },
  {
    "title": "Sanfer Animal",
    "description": "<p class=\"p1\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474;\">Laboratorios Sanfer, en su unidad de negocios Salud Animal adquiere en el a&ntilde;o 2016 a Grupo IDISA, el grupo agroindustrial m&aacute;s importante en la salud animal en M&eacute;xico, el cual amalgama a las empresas:<span class=\"Apple-converted-space\">&nbsp;</span></p>\r\n<p class=\"p2\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474; min-height: 16px;\">&nbsp;</p>\r\n<p class=\"p1\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474;\">a. IASA Investigaci&oacute;n Aplicada, S.A</p>\r\n<p class=\"p1\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474;\">b. NUTEK, S.A.</p>\r\n<p class=\"p1\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474;\">c. ALPES Aves Libres de Pat&oacute;genos Espec&iacute;ficos</p>\r\n<p class=\"p1\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474;\">d. ANDES Aves no desafiadas</p>\r\n<p class=\"p1\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474;\">e. IMSA Incubadora Mexicana, S.A.<span class=\"Apple-converted-space\">&nbsp;</span></p>",
    "website": "https://sanfersaludanimal.com/",
    "smallLogo": "http://206.189.204.88/storage/companies/April2021/TTraKt1fjMpqYr4xNXDf.png",
    "bigLogo": "http://206.189.204.88/storage/companies/April2021/TTraKt1fjMpqYr4xNXDf.png",
    countries: {
      mx: 'mx'
    }
  },
  {
    "title": "Pasteur",
    "description": "<p class=\"p1\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474;\">Farmac&eacute;utica chilena con m&aacute;s de 85 a&ntilde;os de experiencia en el mercado y actualmente cuenta con 225 productos registrados y 160 medicamentos en producci&oacute;n.</p>\r\n<p class=\"p2\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474; min-height: 16px;\">&nbsp;</p>\r\n<p class=\"p1\" style=\"margin: 0px; text-align: justify; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; line-height: normal; font-family: 'SF Pro Display'; color: #747474;\">Laboratorios Pasteur S.A. concentra sus actividades y vinculaciones en el espacio nacional, latinoamericano e internacional y sus especialidades abarcan: pediatr&iacute;a, ginecolog&iacute;a, urolog&iacute;a, cardiolog&iacute;a, medicina general y medicina interna.<span class=\"Apple-converted-space\">&nbsp; </span>Adem&aacute;s, se est&aacute;n ampliando estas especialidades hac&iacute;a la neuropsiquiatr&iacute;a, dermatolog&iacute;a y gastroenterolog&iacute;a.<span class=\"Apple-converted-space\">&nbsp;</span></p>",
    "website": "https://www.lpasteur.cl/",
    "smallLogo": "http://206.189.204.88/storage/companies/April2021/r7SdrhavxX6EH5IHKwGO.png",
    "bigLogo": "http://206.189.204.88/storage/companies/April2021/r7SdrhavxX6EH5IHKwGO.png",
    countries: {
      chl: 'chl'
    }
  }
]